import React from "react";
import MuiDialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import styled from "styled-components";

const StyledDialog = styled(MuiDialog)`
  && .MuiDialog-paperWidthSm {
    width: 100%;
    margin: 0;
    position: fixed;
    bottom: 0;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  @media (min-width: 600px) {
    && .MuiDialog-paperWidthSm {
      position: relative;
      max-width: 440px;
      border-radius: 12px;
    }
  }
`;

const MobileTransition = React.forwardRef(function MobileTransition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Dialog = (props) => {
  const { isOpen, handleOnClose, children } = props;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <StyledDialog
      aria-labelledby="dialog-title"
      open={isOpen}
      onClose={handleOnClose}
      TransitionComponent={isDesktop ? undefined : MobileTransition}
    >
      {children}
    </StyledDialog>
  );
};

export default Dialog;